export default {
  excelLayerList: [],
  excelLayerColorList: [],
  excelLayerSettings: null,
  excelLayerObject: null,
  excelLayerObjectList: null,
  excelLayerIconList: [],
}



// WEBPACK FOOTER //
// ./src/store/excel-layers/defaults.js